<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { INVOICES } from '@/store/types';
import invoicesApi from '@/services/apis/invoices.api';

export default {
  props: {},
  setup() {
    const store = useStore();
    const query = ref(null);
    query.value = invoicesApi.useInvoicesQuery();
    if (query.value) {
      store.commit(INVOICES.SET_INVOICES_QUERY, query);
    }
    return { query };
  },
};
</script>
